<div class="reference_body">


  <main class="reference_main">

    <div class="pink_box"></div>
    <div class="green_box"></div>


    <div class="main">

    <div class="reference_table">
  <div class="scholarship__profile">

        <!-- <div class="info">

            <div class="leave_detail">
                <h5>
                    <span class="available">5</span>
                    <span class="info_name green">Leave Request</span>
                    <span class="sub_info"> Available</span>
                </h5>
            </div>

            <div class="leave_detail">
                <h5>
                    <span class="available">4</span>
                    <span class="info_name peach">Cancellation Request</span>
                    <span class="sub_info"> Available</span>
                </h5>
            </div>

            <div class="leave_detail">
                <h5>
                    <span class="available">5</span>
                    <span class="info_name orange">Approval Request</span>
                    <span class="sub_info"> Available</span>
                </h5>
            </div>
        </div> -->


        <div class="primary_information-card">
            <div class="icons">
                <div class="chat"><button (click)="back()"> <em class="ti-arrow-left"></em>  Back</button></div>
                <div class="edit"><button (click)="onEdit(scholarshipData)"><em class="ti-pencil"></em> Edit</button></div>
                <img src="/assets/images/components/long_curve.svg" alt="" class="top_curve">
                <img src="/assets/images/components/little_balls.svg" alt="" class="box">
                <img src="/assets/images/components/short_curve.svg" alt="" class="short_curve">
            </div>
            <!-- top buttons and designs ----===================================== top buttons and designs -->


            <div class="staff_info">
                <div class="image" [ngStyle]="{'background-image':' url('+ scholarshipData.StudentPassport +')', 'background-position': 'center center', 'background-size': 'cover', 'border-radius': '100%'}"></div>

                <div class="name">
                    <h5 class="staff_name">{{scholarshipData.BeneficarySurname}} {{scholarshipData.BeneficaryFirstname}} {{scholarshipData.BeneficaryOthername}}</h5>
                </div>


                <div class="candidate_details">
                    <h5 class="address">
                        <span class="tag">Address</span>
                        <span class="answer">{{scholarshipData.Address}}</span>
                    </h5>
                    <h5 class="date_of_birth">
                        <span class="tag">Date of birth</span>
                        <span class="answer">{{scholarshipData.DateOfBirth | date}}</span>
                    </h5>
                    <h5 class="category">
                        <span class="tag">Scholarship Type</span>
                        <span class="answer">{{getScholarshipType(scholarshipData.ScholarshipTypeId)}}</span>
                    </h5>
                    <h5 class="date_of_birth">
                        <span class="tag">Scholarship category</span>
                        <span class="answer">{{getScholarshipCategory(scholarshipData.ScholarshipCategoryId)}}</span>
                    </h5>
                </div>
            </div>


        </div>


        <div class="main_info">

          <mat-tab-group>
            <mat-tab label="Scholarship Management">

              <div class="information_card">
                <h4 class="title">Beneficiary's Personal Information</h4>
                <div class="information">

                    <h5 class="info">
                        <span class="tag">Scholarship Award No.</span>
                        <span class="answer">{{scholarshipData.ScholarshipAwardNo}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Scholarship Appl. No.</span>
                        <span class="answer">{{scholarshipData.ScholarshipApplicationNo}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Scholarship Session</span>
                        <span class="answer">{{getScholarshipSession(scholarshipData.ScholarshipYear)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Scholarship Date</span>
                        <span class="answer">{{scholarshipData.ScholarshipDate | date}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">State</span>
                        <span class="answer">{{getState(scholarshipData.State)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">L. G. A</span>
                        <span class="answer">{{getLga(scholarshipData.LGA)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Community</span>
                        <span class="answer">{{getCommunity(scholarshipData.Community)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Phone Number</span>
                        <span class="answer">{{scholarshipData.PhoneNumber}}</span>
                    </h5>

                </div>
            </div>

            <div class="information_card">
                <h4 class="title">Applicant Details Before Award</h4>
                <div class="information">

                    <h5 class="info">
                        <span class="tag">Institution Country</span>
                        <span class="answer">{{getCountry(scholarshipData.InstitutionCountryIdBeforeAward)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Institution State</span>
                        <span class="answer">{{getState(scholarshipData.InstitutionStateIdBeforeAward)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Institution LGA</span>
                        <span class="answer">{{getLga(scholarshipData.InstitutionLGABeforeAward)}}</span>
                    </h5>
                    <h5 class="info">
                      <span class="tag">Institution Community</span>
                      <span class="answer">{{getCommunity(scholarshipData.InstitutionCommunityBeforeAward)}}</span>
                  </h5>
                    <h5 class="info">
                        <span class="tag">Institution Name</span>
                        <span class="answer">{{scholarshipData.InstitutionNameBeforeAward}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Contact Person</span>
                        <span class="answer">{{scholarshipData.ContactPerson}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Contact Phone Number</span>
                        <span class="answer">{{scholarshipData.ContactPhoneNo}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Contact Detail</span>
                        <span class="answer">{{scholarshipData.ContactEmail}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Remark</span>
                        <span class="answer">{{scholarshipData.RemarksBeforeAward}}</span>
                    </h5>

                </div>
            </div>
            <div class="information_card">
                <h4 class="title">Applicant Details On Award</h4>
                <div class="information">

                    <h5 class="info">
                        <span class="tag">Institution Name</span>
                        <span class="answer">{{scholarshipData.InstitutionNameOnAward}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Institution Country</span>
                        <span class="answer">{{getCountry(scholarshipData.InstitutionCountryIdOnAward)}}</span>
                    </h5>
                    <h5 class="info">
                      <span class="tag">Contact Person</span>
                      <span class="answer">{{scholarshipData.ContactPersonOnAward}}</span>
                  </h5>
                  <h5 class="info">
                    <span class="tag">Contact Phone</span>
                    <span class="answer">{{scholarshipData.ContactPhoneNoOnAward}}</span>
                </h5>
                    <h5 class="info">
                      <span class="tag">Contact Email</span>
                      <span class="answer">{{scholarshipData.ContactEmailOnAward}}</span>
                  </h5>
                  <h5 class="info">
                    <span class="tag">Contact Url</span>
                    <span class="answer">{{scholarshipData.ContactUrlOnAward}}</span>
                </h5>
                    <h5 class="info">
                        <span class="tag">Institution State</span>
                        <span class="answer">{{getState(scholarshipData.InstitutionStateIdOnAward)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Institution LGA</span>
                        <span class="answer">{{getLga(scholarshipData.InstitutionLGAOnAward)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Institution community</span>
                        <span class="answer">{{getCommunity(scholarshipData.InstitutionCommunityOnAward)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Duration</span>
                        <span class="answer">{{getDuration(scholarshipData.ScholarshipAwardDurationId)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Course Of Study</span>
                        <span class="answer">{{getCourseOfStudy(scholarshipData.CourseOfStudy)}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Institution Address</span>
                        <span class="answer">{{scholarshipData.InstitutionAddressOnAward}}</span>
                    </h5>
                    <h5 class="info">
                        <span class="tag">Remarks</span>
                        <span class="answer">{{scholarshipData.RemarksOnAward}}</span>
                    </h5>

                </div>
            </div>
            </mat-tab>
            <mat-tab label="Scholarship Payment">


  <div class="custom_table">

      <div class="thead">
        <span class="head">S/N</span>
        <span class="head">Student Name</span>
        <span class="head">Award No</span>
        <span class="head">Amount Paid</span>

      </div>

      <div class="tbody the_table-row">
        <div
          class="td"
          *ngFor="
            let payment of scholarshipPayments;
            index as i
          " (click)="openViewPaymentModal(payment)" style="cursor: pointer;">
          <span class="head">{{ i + 1 }}</span>
          <span >{{payment.StudentName}}</span>
          <span>{{payment.ScholarshipAwardNo}}</span>
          <span>{{payment.AmountPaid | currency:getCurrencyCode(payment.CurrencyId):'symbol-narrow':'3.2-2'}}</span>

        </div>
      </div>

      <div class="submit">
        <button class="submit_button mr-3" (click)="openCreatePaymentModal()" >
          Add New Payment
        </button>
        <button class="submit_button" (click)="openReportPaymentModal()">
          View Payment Report
        </button>
      </div>

  </div>
            </mat-tab>
          </mat-tab-group>

        </div>



    </div>

    </div>
</div>
</main>

</div>
